import type React from 'react';
import { clearEmployeeNotFoundFlag } from '../contexts/AuthContext';
import { colors } from '../theme/colors';
import { logout } from '../utils/auth';
import { Footer } from './VersionDisplay';

export const ContactSupport: React.FC = () => {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: colors.neutral.grey[50],
        padding: '2rem',
      }}
    >
      <div
        style={{
          maxWidth: '600px',
          width: '100%',
          backgroundColor: colors.neutral.white,
          borderRadius: '0.75rem',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          padding: '3rem',
          textAlign: 'center',
        }}
      >
        <div
          style={{
            fontSize: '4rem',
            marginBottom: '1.5rem',
          }}
        >
          🔒
        </div>

        <h1
          style={{
            fontSize: '2rem',
            fontWeight: '700',
            color: colors.secondary.text,
            marginBottom: '1rem',
          }}
        >
          Access Restricted
        </h1>

        <p
          style={{
            fontSize: '1.125rem',
            color: colors.neutral.grey[600],
            marginBottom: '2rem',
            lineHeight: '1.6',
          }}
        >
          Your account is not registered in the system. Please contact Administrator to request
          access.
        </p>

        <div
          style={{
            backgroundColor: colors.neutral.grey[100],
            borderRadius: '0.5rem',
            padding: '2rem',
            marginBottom: '2rem',
            textAlign: 'left',
          }}
        >
          <h2
            style={{
              fontSize: '1.25rem',
              fontWeight: '600',
              color: colors.secondary.text,
              marginBottom: '1rem',
            }}
          >
            Contact Information
          </h2>

          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '1rem',
            }}
          >
            <div>
              <strong style={{ color: colors.secondary.text }}>Email:</strong>
              <div style={{ color: colors.neutral.grey[700], marginTop: '0.25rem' }}>
                christian.miguel-langstrof@ppe-intelligence.com
              </div>
            </div>
          </div>
        </div>

        <button
          onClick={async () => {
            try {
              // Clear backend session cookies
              await logout();
              // Clear localStorage flags
              clearEmployeeNotFoundFlag();
              // Clear all cookies (client-side)
              document.cookie.split(';').forEach((c) => {
                document.cookie = c
                  .replace(/^ +/, '')
                  .replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
              });
              // Redirect to login page
              window.location.href = '/';
            } catch (error) {
              // Still redirect even if logout fails
              clearEmployeeNotFoundFlag();
              window.location.href = '/';
            }
          }}
          style={{
            backgroundColor: colors.accent.blue,
            color: colors.neutral.white,
            border: 'none',
            borderRadius: '0.5rem',
            padding: '0.75rem 2rem',
            fontSize: '1rem',
            fontWeight: '600',
            cursor: 'pointer',
            transition: 'background-color 0.2s',
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.backgroundColor = colors.accent.blue;
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.backgroundColor = colors.accent.blue;
          }}
        >
          Return to Login
        </button>
      </div>

      <div style={{ marginTop: '2rem' }}>
        <Footer />
      </div>
    </div>
  );
};
